<template>
  <div id="login">
    <v-content>
      <v-container
        class="fill-height"
        v-if="
          $store.getters.get_VerificatnStatus == 0 ||
          $store.getters.get_VerificatnStatus == 2 ||
          $store.getters.get_VerificatnStatus == 3
        "
        fluid
      >
        <v-row align="center" justify="center" style="margin-top: 80px">
          <v-card
            shaped
            outlined
            :width="!isMobile ? '1200' : '320'"
            align="center"
            justify="center"
          >
            <v-row>
              <v-col cols="12" md="4" lg="4" xl="4" sm="12" xs="12">
                <v-img
                  class="mt-n2"
                  src="@/assets/glyd1.svg"
                  width="400"
                  height="180"
                ></v-img>
              </v-col>
              <v-col cols="12" md="7" lg="7" xl="7" sm="12" xs="12">
                <v-row
                  :style="
                    isMobile
                      ? 'margin-top:60px'
                      : 'margin-top:130px ; margin-left:50px'
                  "
                >
                  <!-- <h1 class="mt-n3">Verify your business</h1> -->
                  <caption
                    v-if="this.e1 == 1"
                    style="font-style: italic; font-family: Times New Roman"
                    class="font-weight-regular primary--text ml-2 mr-2"
                  >
                    Welcome to Glyd! Please register your company by entering
                    your personal and company details.
                  </caption>
                  <caption
                    v-if="this.e1 == 2"
                    style="font-style: italic; font-family: Times New Roman"
                    class="font-weight-regular text-lg-left primary--text ml-2 mr-2"
                  >
                    Please enter the Registered Address and Business Address of
                    your Company.
                  </caption>
                  <caption
                    v-if="this.e1 == 5"
                    style="font-style: italic; font-family: Times New Roman"
                    class="font-weight-regular text-lg-left primary--text ml-2 mr-2"
                  >
                    Enter details of your company Bank Account from which you
                    will load funds into Glyd Cards. Bank account must be in the
                    name of the company (or owner only in case of
                    proprietorships). You may enter one or more Bank Account
                    details.
                  </caption>
                  <caption
                    v-if="this.e1 == 3"
                    style="font-style: italic; font-family: Times New Roman"
                    class="font-weight-regular text-lg-left primary--text ml-2 mr-2"
                  >
                    Kindly upload the required documents by first clicking on
                    Select Document.
                  </caption>
                  <caption
                    v-if="this.e1 == 6"
                    style="font-style: italic; font-family: Times New Roman"
                    class="font-weight-regular text-lg-left primary--text ml-2 mr-2"
                  >
                    Kindly check all the details and click on submit button to
                    submit the application.
                  </caption>
                  <caption
                    v-if="this.e1 == 4"
                    style="font-style: italic; font-family: Times New Roman"
                    class="font-weight-regular text-lg-left primary--text ml-2 mr-2"
                  >
                    Kindly enter details of your Shareholder or Director who
                    will be issued the first card.
                  </caption>
                </v-row>
              </v-col>

              <v-col cols="12" md="12" lg="12" xl="12" sm="12" xs="12">
                <v-stepper v-model="e1">
                  <v-stepper-header>
                    <v-stepper-step
                      color="green"
                      class="caption"
                      :complete="e1 > 1"
                      step="1"
                      >Basic Details</v-stepper-step
                    >

                    <v-divider></v-divider>

                    <v-stepper-step
                      color="green"
                      class="caption"
                      :complete="e1 > 2"
                      step="2"
                      >Address</v-stepper-step
                    >

                    <v-divider></v-divider>

                    <v-stepper-step
                      color="green"
                      class="caption"
                      :complete="e1 > 3"
                      step="3"
                      >Upload Docs</v-stepper-step
                    >
                    <v-divider></v-divider>

                    <v-stepper-step
                      color="green"
                      class="caption"
                      :complete="e1 > 4"
                      step="4"
                      >First Card info</v-stepper-step
                    >

                    <v-divider></v-divider>

                    <v-stepper-step
                      color="green"
                      class="caption"
                      :complete="e1 > 5"
                      step="5"
                      >Bank Information</v-stepper-step
                    >

                    <v-divider></v-divider>

                    <!-- <v-stepper-step :complete="e1 > 5" step="5">
                Other Information</v-stepper-step
              > -->
                    <v-stepper-step
                      color="green"
                      class="caption"
                      :complete="e1 > 6"
                      step="6"
                      >Preview</v-stepper-step
                    >

                    <v-divider></v-divider>

                    <v-stepper-step
                      color="green"
                      class="caption"
                      :complete="e1 > 7"
                      step="7"
                      >Verification Status</v-stepper-step
                    >
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card height="fit-content" flat>
                        <v-form ref="formStep1" lazy-validation>
                          <v-row class="pa-0">
                            <v-col
                              cols="12"
                              md="6"
                              sm="12"
                              xl="6"
                              lg="6"
                              xs="12"
                            >
                              <v-card-title class="text ml-n3 mt-n5"
                                >Enter your Personal Details</v-card-title
                              >
                              <v-row class="mb-n9">
                                <v-col
                                  cols="12"
                                  md="12"
                                  sm="12"
                                  xl="12"
                                  lg="12"
                                  xs="12"
                                >
                                  <v-text-field
                                    v-model="getcorpList.first_name"
                                    label="First Name *"
                                    color="primary"
                                    :rules="rules.title"
                                    @keydown.space="preventLeadingSpace"
                                    maxlength="25"
                                    required
                                    outlined
                                    dense
                                    v-on:keypress="isLetter($event)"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row class="mb-n9">
                                <v-col
                                  cols="12"
                                  md="12"
                                  sm="12"
                                  xl="12"
                                  lg="12"
                                  xs="12"
                                >
                                  <v-text-field
                                    v-model="getcorpList.middle_name"
                                    label="Middle Name"
                                    v-on:keypress="isLetter($event)"
                                    color="primary"
                                    maxlength="25"
                                    required
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row class="mb-n9">
                                <v-col
                                  cols="12"
                                  md="12"
                                  sm="12"
                                  xl="12"
                                  lg="12"
                                  xs="12"
                                >
                                  <v-text-field
                                    v-model="getcorpList.last_name"
                                    label="Last Name"
                                    color="primary"
                                    @keydown.space="preventLeadingSpace"
                                    v-on:keypress="isLetter($event)"
                                    maxlength="25"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row class="mb-n9">
                                <v-col
                                  cols="12"
                                  md="6"
                                  sm="12"
                                  xl="6"
                                  lg="6"
                                  xs="12"
                                >
                                  <v-text-field
                                    v-model="getcorpList.designation"
                                    v-on:keypress="isLetter($event)"
                                    label="Designation *"
                                    color="primary"
                                    @keydown.space="preventLeadingSpace"
                                    :rules="rules.title"
                                    maxlength="30"
                                    required
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                  sm="12"
                                  xl="6"
                                  lg="6"
                                  xs="12"
                                  :class="isMobile ? 'mt-n6' : ''"
                                >
                                  <v-text-field
                                    v-model="getcorpList.contact_num"
                                    label="Contact Number *"
                                    @keypress="isNumber($event)"
                                    maxlength="10"
                                    prefix="+60"
                                    :rules="[
                                      (v) => !!v || 'Required',
                                      (v) =>
                                        /^[1-9][0-9]*$/.test(v) ||
                                        'Invalid Contact Number',
                                      (v) =>
                                        (v && v.length < 11) ||
                                        'Invalid Contact Number',
                                      (v) =>
                                        (v && v.length > 8) ||
                                        'Invalid Contact Number',
                                    ]"
                                    required
                                    outlined
                                    dense
                                  ></v-text-field>
                                  <!-- @input="validateInput1"
                                    :color="redcolor"
                                    :error="error"
                                    :hint="invalidcontact" -->
                                </v-col>
                              </v-row>
                              <v-row class="mb-n9">
                                <v-col
                                  cols="12"
                                  md="12"
                                  sm="12"
                                  xl="12"
                                  lg="12"
                                  xs="12"
                                >
                                  <v-text-field
                                    outlined
                                    dense
                                    append-icon="mdi-person"
                                    :rules="[rules1.required, rules1.email]"
                                    label="E-mail *"
                                    readonly
                                    v-model="$store.getters.get_useremail"
                                    value
                                  ></v-text-field
                                ></v-col>
                              </v-row>
                              <!-- <v-row class="mb-n9">
                          <v-col cols="8" md="8" sm="8">
                            <v-text-field
                              v-model="getcorpList.contact_num"
                              label="Contact Number"
                              @keypress="isNumber(event)"
                              maxlength="12"
                              color="primary"
                              prefix="+60"
                              :rules="rules.title"
                              required
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                        </v-row> -->
                            </v-col>
                            <v-divider light vertical class="mx-n1"></v-divider>
                            <v-col
                              cols="12"
                              md="6"
                              sm="12"
                              xl="6"
                              lg="6"
                              xs="12"
                            >
                              <v-row>
                                <v-card-title class="text mt-n2"
                                  >Enter your Company Details</v-card-title
                                >
                              </v-row>
                              <v-row class="mb-n7">
                                <v-col
                                  cols="12"
                                  md="12"
                                  sm="12"
                                  xl="12"
                                  lg="12"
                                  xs="12"
                                >
                                  <v-textarea
                                    class="mt-n3"
                                    v-model="getcorpList.comp_name"
                                    @keydown.space="preventLeadingSpace"
                                    label="Company Name *"
                                    color="primary"
                                    required
                                    dense
                                    :rules="[rules1.required]"
                                    outlined
                                    auto-grow
                                    maxlength="100"
                                    rows="1"
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                              <v-row class="mt-1">
                                <v-col
                                  cols="12"
                                  md="6"
                                  sm="12"
                                  xl="6"
                                  lg="6"
                                  xs="12"
                                >
                                  <v-select
                                    class="mt-n0"
                                    :items="typeofentities"
                                    v-model="getcorpList.ent_type"
                                    :rules="rules.title"
                                    label="Type of Entity *"
                                    required
                                    outlined
                                    dense="dense"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                  sm="12"
                                  xl="6"
                                  lg="6"
                                  xs="12"
                                  :class="isMobile ? 'mt-n6' : ''"
                                >
                                  <v-text-field
                                    v-model="getcorpList.registration_num"
                                    class="mt-n0"
                                    label="Company Registration Number *"
                                    color="primary"
                                    maxlength="25"
                                    :rules="[
                                      (v) => !!v || 'Required',

                                      (v) =>
                                        (v && v.length > 3) ||
                                        'min 4 characters',
                                    ]"
                                    required
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row class="mt-n6">
                                <v-col
                                  cols="12"
                                  md="12"
                                  sm="12"
                                  xl="12"
                                  lg="12"
                                  xs="12"
                                >
                                  <v-select
                                    :items="natureofbusinesses"
                                    v-model="getcorpList.nat_of_busn"
                                    :rules="rules.title"
                                    label="Nature of business *"
                                    required
                                    outlined
                                    dense="dense"
                                  ></v-select>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                        <v-row>
                          <v-spacer />
                          <v-btn
                            class="mr-4 mt-n2"
                            color="primary"
                            @click="basicmethod"
                            >Continue</v-btn
                          >

                          <!-- <v-btn  text> back </v-btn> -->
                        </v-row>
                        <v-card-actions></v-card-actions>
                      </v-card>
                    </v-stepper-content>

                    <!-- ******************************************** -->

                    <v-stepper-content step="2">
                      <v-form ref="formStep2" lazy-validation>
                        <v-card height="fit-content" flat>
                          <v-row class="pa-0">
                            <v-card-title class="text"
                              >Registered Address</v-card-title
                            >
                          </v-row>
                          <v-row class="mt-n4">
                            <v-col
                              cols="12"
                              md="6"
                              sm="12"
                              xl="6"
                              lg="6"
                              xs="12"
                            >
                              <v-textarea
                                v-model="getaddresslist.addressline1"
                                label="Address Line 1 *"
                                outlined
                                auto-grow
                                @keydown.space="preventLeadingSpace"
                                :rules="[rules1.required, rules1.length]"
                                rows="2"
                                row-height="15"
                                maxlength="100"
                              ></v-textarea>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                              sm="12"
                              xl="6"
                              lg="6"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-textarea
                                v-model="getaddresslist.addressline2"
                                label="Address Line 2 *"
                                outlined
                                auto-grow
                                @keydown.space="preventLeadingSpace"
                                :rules="[rules1.required, rules1.length]"
                                rows="2"
                                row-height="15"
                                maxlength="100"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row class="mt-n6">
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                            >
                              <v-text-field
                                v-model="getaddresslist.city"
                                label="City *"
                                color="primary"
                                @keydown.space="preventLeadingSpace"
                                :rules="rules.title"
                                v-on:keypress="isLetter($event)"
                                required
                                outlined
                                dense
                                maxlength="20"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-select
                                v-model="getaddresslist.state"
                                label="Select State *"
                                :rules="rules.title"
                                color="primary"
                                :items="stateList"
                                item-text="state_name"
                                required
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-text-field
                                v-model="getaddresslist.country"
                                label="Country"
                                readonly
                                :rules="rules.title"
                                color="primary"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-text-field
                                v-model="getaddresslist.zip_code"
                                label="Postal Code *"
                                maxlength="5 *"
                                :rules="[
                                  (v) => !!v || 'Required',
                                  (v) =>
                                    /^(?=[a-zA-Z0-9]{0,16}$)[0-9 +-]{0,16}$/.test(
                                      v
                                    ) || 'Invalid Input',
                                  (v) => v.length >= 3 || 'Mini 3 characters',
                                ]"
                                @keypress="isNumber($event)"
                                color="primary"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="mt-n8 pa-0">
                            <v-card-title class="text"
                              >Business Address</v-card-title
                            >
                            <v-col>
                              <v-checkbox
                                class="mt-4"
                                dense
                                v-model="checkbox"
                                @click="calladdress"
                                label="Same As Registered Address?"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row v-if="checkbox == false" class="mt-n6">
                            <v-col
                              cols="12"
                              md="6"
                              sm="12"
                              xl="6"
                              lg="6"
                              xs="12"
                            >
                              <v-textarea
                                v-model="getaddresslist1.addressline1"
                                label="Address Line 1 *"
                                @keydown.space="preventLeadingSpace"
                                outlined
                                auto-grow
                                :rules="[rules1.required, rules1.length]"
                                rows="2"
                                row-height="15"
                                maxlength="100"
                              ></v-textarea>
                            </v-col>
                            <v-col
                              cols="12"
                              md="6"
                              sm="12"
                              xl="6"
                              lg="6"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-textarea
                                v-model="getaddresslist1.addressline2"
                                label="Address Line 2 *"
                                @keydown.space="preventLeadingSpace"
                                outlined
                                auto-grow
                                maxlength="100"
                                rows="1"
                                :rules="[rules1.required, rules1.length]"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row v-if="checkbox == false" class="mt-n6">
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                            >
                              <v-text-field
                                v-model="getaddresslist1.city"
                                label="City"
                                @keydown.space="preventLeadingSpace"
                                color="primary"
                                :rules="rules.title"
                                v-on:keypress="isLetter($event)"
                                maxlength="20"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-select
                                v-model="getaddresslist1.state"
                                label="Select State"
                                color="primary"
                                :items="stateList"
                                item-text="state_name"
                                :rules="rules.title"
                                required
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-text-field
                                v-model="getaddresslist1.country"
                                readonly
                                label="Country *"
                                color="primary"
                                :rules="rules.title"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="12"
                              xl="3"
                              lg="3"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-text-field
                                v-model="getaddresslist1.zip_code"
                                label="Enter Postal Code *"
                                @keypress="isNumber($event)"
                                maxlength="5"
                                :rules="[
                                  (v) => !!v || 'Required',
                                  (v) =>
                                    /^(?=[a-zA-Z0-9]{0,16}$)[0-9 +-]{0,16}$/.test(
                                      v
                                    ) || 'Invalid Input',
                                  (v) => v.length >= 3 || 'Mini 3 characters',
                                ]"
                                color="primary"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="mt-n3 mr-1">
                            <v-spacer />
                            <v-btn @click="back" text>back</v-btn>
                            <v-btn color="primary" @click="addressmethod"
                              >Continue</v-btn
                            >
                          </v-row>
                          <v-card-actions></v-card-actions>
                        </v-card>
                      </v-form>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-card height="fit-content" flat>
                        <v-row>
                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xl="12"
                            lg="12"
                            xs="11"
                          >
                            <v-data-table
                              :headers="headersUploader"
                              :items="fileList"
                              loading-text="Uploading.."
                              dense
                            >
                              <template v-slot:[`item.doc_url`]="{ item }">
                                <v-avatar tile size="36" class="mt-1">
                                  <img
                                    v-if="
                                      item.docExtn == 'jpeg' ||
                                      item.docExtn == 'JPEG' ||
                                      item.docExtn == 'jpg' ||
                                      item.docExtn == 'JPG' ||
                                      item.docExtn == 'png' ||
                                      item.docExtn == 'PNG' ||
                                      item.docExtn == 'webp' ||
                                      item.docExtn == 'WEBP'
                                    "
                                    :src="item.doc_url"
                                    alt="error"
                                    @click="openImageInNewTab(item.doc_url)"
                                  />

                                  <v-icon
                                    @click="openImageInNewTab(item.doc_url)"
                                    v-else-if="item.docExtn == 'pdf'"
                                    left
                                    color="red"
                                    >mdi-file-pdf</v-icon
                                  >
                                  <v-icon
                                    @click="openImageInNewTab(item.doc_url)"
                                    v-else-if="
                                      item.docExtn == 'xls' ||
                                      item.docExtn == 'xlsx'
                                    "
                                    left
                                    color="green"
                                    >mdi-file-excel</v-icon
                                  >
                                  <v-icon
                                    @click="openImageInNewTab(item.doc_url)"
                                    v-else-if="
                                      item.docExtn == 'doc' ||
                                      item.docExtn == 'docx'
                                    "
                                    left
                                    color="blue"
                                    >mdi-file-word</v-icon
                                  >
                                  <v-icon
                                    @click="openImageInNewTab(item.doc_url)"
                                    v-else
                                    left
                                    color="blue"
                                    >mdi-file-document</v-icon
                                  >
                                </v-avatar>
                                <v-tooltip bottom color="primary">
                                  <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                      <span class="caption justify-center">
                                        {{
                                          item.fileName.length >= 15
                                            ? item.fileName.substr(0, 10) +
                                              "..."
                                            : item.fileName
                                        }}</span
                                      >
                                    </div>
                                  </template>
                                  <span class="primary">{{
                                    item.fileName
                                  }}</span>
                                </v-tooltip>
                              </template>
                              <template
                                v-slot:[`item.doc_name`]="{ item }"
                                v-if="isMobile"
                              >
                                <v-tooltip bottom color="primary" class="pa-3">
                                  <template v-slot:activator="{ on }">
                                    <h4 class="caption" v-on="on">
                                      {{
                                        item.doc_name.length >= 20
                                          ? item.doc_name.substr(0, 20) + "..."
                                          : item.doc_name
                                      }}
                                    </h4>
                                  </template>
                                  <span class="caption">{{
                                    item.doc_name
                                  }}</span>
                                </v-tooltip>
                              </template>

                              <template v-slot:[`item.actions`]="{ item }">
                                <v-icon
                                  small
                                  color="red"
                                  @click="confirmdeleteItem(item)"
                                  >mdi-delete</v-icon
                                >
                              </template>
                              <template v-slot:[`item.Status`]="{}">
                                <v-icon color="green" medium
                                  >mdi-check-bold</v-icon
                                >
                              </template>
                              <template v-slot:top>
                                <v-form ref="uploadForm">
                                  <v-row>
                                    <v-col
                                      cols="12"
                                      md="4"
                                      sm="12"
                                      xl="4"
                                      lg="4"
                                      xs="12"
                                      class="mt-n2"
                                    >
                                      <label class="caption">Documents</label>
                                      <v-select
                                        v-model="documentsupload"
                                        :items="documentsList"
                                        dense
                                        solo
                                        shaped
                                        label="Select Document"
                                        return-object
                                      ></v-select>
                                      <!-- @change="documentChange()" -->
                                    </v-col>
                                    <v-col
                                      cols="12"
                                      md="3"
                                      sm="12"
                                      xs="12"
                                      lg="3"
                                      xl="3"
                                      class="mt-n2"
                                      v-if="
                                        documentsupload == 'Other Documents'
                                      "
                                    >
                                      <label class="caption"
                                        >Document Name</label
                                      >
                                      <v-text-field
                                        v-model="documentsuploadname"
                                        dense
                                        solo
                                        shaped
                                        label="Document name"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                      cols="12"
                                      md="4"
                                      sm="12"
                                      xl="4"
                                      lg="4"
                                      xs="12"
                                      class="mt-n2"
                                    >
                                      <label class="caption"
                                        >Upload Document</label
                                      >
                                      <v-file-input
                                        v-model="file"
                                        dense
                                        :disabled="!documentsupload"
                                        show-size
                                        counter
                                        solo
                                        label="Upload"
                                        @change="beforeaddingfile()"
                                      ></v-file-input>
                                      <template v-slot:selection="{ file }">
                                        <v-chip small label color="primary">
                                          <span class="caption">{{
                                            file
                                          }}</span>
                                        </v-chip>
                                      </template>
                                    </v-col>
                                  </v-row>
                                </v-form>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                        <v-dialog
                          v-model="confirmDeleteDialog"
                          width="400"
                          persistent
                        >
                          <v-card>
                            <v-card-text class="pt-6 black--text subtitle-1"
                              >Are you sure you want to proceed ?</v-card-text
                            >

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="secondary"
                                rounded
                                text
                                @click="confirmDeleteDialog = false"
                                >Back</v-btn
                              >
                              <v-btn
                                rounded
                                @click="deleteItemFile()"
                                color="primary"
                                dark
                                >Submit</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-card>
                      <v-card-actions />
                      <v-card-actions />

                      <v-row class="mr-1">
                        <v-spacer />
                        <v-btn @click="backmethod" text>back</v-btn>
                        <v-btn
                          color="primary"
                          :disabled="loadingAdd"
                          @click="dovalidatin()"
                          >Continue</v-btn
                        >
                      </v-row>
                      <v-card-actions />
                      <v-card-actions />
                    </v-stepper-content>
                    <!-- %%$%$$$$$$$$$$$$$$$$ -->
                    <v-stepper-content step="4">
                      <v-card class="elevation-0">
                        <v-form ref="cardInfo">
                          <v-row class="mt-2">
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xl="4"
                              lg="4"
                              xs="12"
                            >
                              <v-text-field
                                v-model="cardIFullname"
                                label="First Name *"
                                @keydown.space="preventLeadingSpace"
                                color="primary"
                                :rules="rules.title"
                                v-on:keypress="isLetter($event)"
                                maxlength="25"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xl="4"
                              lg="4"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-text-field
                                v-model="cardIMiddlename"
                                label="Middle Name"
                                color="primary"
                                required
                                outlined
                                v-on:keypress="isLetter($event)"
                                maxlength="25"
                                max
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xl="4"
                              lg="4"
                              xs="12"
                              :class="isMobile ? 'mt-n6' : ''"
                            >
                              <v-text-field
                                v-model="cardILastname"
                                label="Last Name *"
                                color="primary"
                                required
                                v-on:keypress="isLetter($event)"
                                maxlength="25"
                                outlined
                                dense
                                :rules="rules.title"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xl="4"
                              lg="4"
                              xs="12"
                              class="mt-n6"
                            >
                              <v-text-field
                                outlined
                                dense
                                append-icon="mdi-person"
                                :rules="[rules1.required, rules1.email]"
                                label="E-mail *"
                                value
                                v-model="cardIEmail"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xl="4"
                              lg="4"
                              xs="12"
                              class="mt-n6"
                            >
                              <v-text-field
                                dense
                                label="Designation "
                                @keydown.space="preventLeadingSpace"
                                v-model="carddesignatn"
                                maxlength="30"
                                v-on:keypress="isLetter($event)"
                                outlined
                              ></v-text-field>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xl="4"
                              lg="4"
                              xs="12"
                              class="mt-n6"
                            >
                              <v-text-field
                                dense
                                label="Passport/NRIC No. *"
                                :rules="[
                                  (v) => !!v || 'Required',
                                  (v) =>
                                    /^(?=[a-zA-Z0-9]{0,30}$)[0-9a-zA-Z]{0,64}$/.test(
                                      v
                                    ) || 'Invalid Input',
                                  (v) =>
                                    (v && v.length < 19) ||
                                    'Invalid Passport/NRIC No.',
                                ]"
                                maxlength="18"
                                v-model="cardNRIC"
                                outlined
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              sm="12"
                              xl="4"
                              lg="4"
                              xs="12"
                              class="mt-n6"
                            >
                              <v-text-field
                                dense
                                placeholder="Mobile Number *"
                                :rules="[
                                  (v) => !!v || 'Required',
                                  (v) =>
                                    /^[1-9][0-9]*$/.test(v) ||
                                    'Invalid Contact Number',
                                  (v) =>
                                    (v && v.length < 11) ||
                                    'Invalid Contact Number',
                                  (v) =>
                                    (v && v.length > 8) ||
                                    'Invalid Contact Number',
                                ]"
                                maxlength="10"
                                label="Mobile Number *"
                                prefix="+60"
                                v-model="cardMobilNo"
                                @keypress="isNumber($event)"
                                outlined
                              ></v-text-field>
                              <!-- @input="validateInput"
                                :color="redcolor"
                                :error="error"
                                :hint="invalidcontact" -->
                            </v-col>
                            <!-- <v-col class="mt-n6" cols="1">
                        <v-text-field
                          dense
                          label="Cc*"
                          v-model="countryCode"
                          maxlength="12"
                          readonly
                          @keypress="isNumber(event)"
                          outlined
                        ></v-text-field
                      ></v-col> -->
                          </v-row>
                        </v-form>
                        <v-row class="mt-n2 mr-1">
                          <v-spacer />
                          <v-btn @click="back" text>back</v-btn>
                          <v-btn color="primary" @click="stepperforth()"
                            >Continue</v-btn
                          >
                        </v-row>

                        <v-card-actions></v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-content step="5">
                      <v-card height="fit-content" flat>
                        <v-row>
                          <v-spacer />

                          <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12">
                            <v-dialog
                              persistent
                              v-model="AddBankDialog"
                              width="600"
                            >
                              <v-toolbar dark class="primary" dense>
                                <!-- <v-toolbar-title
                            v-if="editcheck == false"
                            class="white--text"
                            >Add Bank</v-toolbar-title
                          > -->
                                <v-toolbar-title
                                  v-if="editcheck == true"
                                  class="white--text"
                                  >Edit Bank Details</v-toolbar-title
                                >
                                <v-toolbar-title
                                  v-if="editcheck == false"
                                  class="white--text"
                                  >Add Bank Details</v-toolbar-title
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  dark
                                  @click="
                                    $refs.Addbankinfo.resetValidation();
                                    $refs.Addbankinfo.reset();
                                    AddBankDialog = false;
                                    editcheck = false;
                                  "
                                >
                                  <v-icon color="white">mdi-close</v-icon>
                                </v-btn>
                              </v-toolbar>
                              <template #activator="{ on: AddBankDialog }">
                                <!-- <v-tooltip bottom color="primary">
                            <template #activator="{ on: tooltip }"> -->
                                <v-btn
                                  rounded
                                  absolute
                                  class="primary white--text ml-7"
                                  v-on="{ ...AddBankDialog }"
                                >
                                  <v-icon>mdi-plus</v-icon>Add
                                </v-btn>
                                <!-- </template> -->
                                <!-- <span class="white--text">Add Bank Info</span> -->
                                <!-- </v-tooltip> -->
                              </template>
                              <v-card>
                                <v-divider></v-divider>
                                <v-form ref="Addbankinfo">
                                  <v-row class="mt-8 mx-7">
                                    <v-select
                                      v-model="AccType"
                                      :rules="rules.title"
                                      label="Account Type *"
                                      color="primary"
                                      required
                                      :items="AccTypes"
                                      outlined
                                      dense
                                    ></v-select>
                                  </v-row>
                                  <v-row class="mx-7">
                                    <v-text-field
                                      v-model="AccName"
                                      :rules="rules.title"
                                      color="primary"
                                      label="Account Name *"
                                      maxlength="35"
                                      v-on:keypress="isLetter($event)"
                                      required
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-row>
                                  <v-row class="mx-7">
                                    <v-select
                                      v-model="BankName"
                                      :rules="rules.title"
                                      label="Bank Name *"
                                      color="primary"
                                      required
                                      :items="BankNames"
                                      outlined
                                      dense
                                    ></v-select>
                                  </v-row>
                                  <v-row class="mx-7">
                                    <v-text-field
                                      v-model="AccNo"
                                      :rules="[
                                        (v) => !!v || 'Required',
                                        (v) =>
                                          /^(?=[a-zA-Z0-9]{0,16}$)[0-9 +-]{0,16}$/.test(
                                            v
                                          ) || 'Invalid Input',
                                        (v) =>
                                          v.length >= 8 || 'Mini 8 characters',
                                        (v) =>
                                          v.length <= 16 || 'Max 16 characters',
                                      ]"
                                      color="primary"
                                      label="Account Number *"
                                      required
                                      maxlength="16"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-row>
                                </v-form>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    v-if="editcheck == false"
                                    class="primary white--text"
                                    @click="createbankinfo('0')"
                                    >Add Account</v-btn
                                  >
                                  <v-btn
                                    v-if="editcheck == true"
                                    class="primary white--text"
                                    @click="savebankinfo"
                                    >save</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>

                          <v-col
                            cols="12"
                            md="12"
                            sm="12"
                            xl="12"
                            lg="12"
                            xs="12"
                          >
                            <v-data-table
                              :headers="showBankHeader"
                              :items="getbankList"
                              hide-default-footer
                              v-model="selected"
                              class="mt-7 elevation-1"
                              hid
                              item-key="bank_account_num"
                            >
                              <template v-slot:[`item.primary_acc`]="{ item }">
                              
                                <v-simple-checkbox
                                  v-model="item.primary_acc"
                                  @click="changeCheckBox(item)"
                                ></v-simple-checkbox>
                              </template>
                              <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      @click="showContent(item)"
                                      small
                                      class="mr-2"
                                      color="primary"
                                      v-on="on"
                                      >mdi-pencil</v-icon
                                    >
                                  </template>
                                  <span>Edit</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      @click="deleteContent(item)"
                                      small
                                      class="mr-2"
                                      v-on="on"
                                      color="red"
                                      >mdi-delete</v-icon
                                    >
                                  </template>
                                  <span>Delete</span>
                                </v-tooltip>
                              </template>
                              <template
                                v-slot:[`item.bank_name`]="{ item }"
                                v-if="isMobile"
                              >
                                <v-tooltip bottom color="primary" class="pa-3">
                                  <template v-slot:activator="{ on }">
                                    <h4 class="caption" v-on="on">
                                      {{
                                        item.bank_name.length >= 15
                                          ? item.bank_name.substr(0, 15) + "..."
                                          : item.bank_name
                                      }}
                                    </h4>
                                  </template>
                                  <span class="caption">{{
                                    item.bank_name
                                  }}</span>
                                </v-tooltip>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>

                        <v-row class="mr-1 mb-4">
                          <v-spacer />
                          <v-btn class="mt-5" @click="back5()" text>back</v-btn>
                          <v-btn
                            color="primary"
                            class="mt-5"
                            @click="createbankinfo('1')"
                            >Continue</v-btn
                          >
                        </v-row>
                      </v-card>
                      <v-dialog
                        v-model="dialogDelete"
                        max-width="400px"
                        persist
                      >
                        <v-card class="overflow-hidden">
                          <v-toolbar class="elevation-0" dense>
                            <span>
                              Are you sure you want to delete this item?
                            </span>
                            <v-spacer></v-spacer>
                            <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
                          </v-toolbar>
                          <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

                          <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-row class="mt-2" style="margin-left: 200px">
                              <v-btn
                                text
                                width="90px"
                                class="mb-4 red--text"
                                @click="closeDelete"
                                >Back</v-btn
                              >
                              <v-btn
                                text
                                width="90px"
                                class="mb-4 primary--text"
                                @click="deleteItemConfirm()"
                                >Submit</v-btn
                              >
                            </v-row>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-stepper-content>
                    <v-stepper-content step="6">
                      <Preview v-on:backChild="finalsubmit" v-if="e1 == 6" />
                    </v-stepper-content>
                    <v-stepper-content step="7">
                      <v-card
                        class="elevation-0 d-flex justify-center"
                        justify="center"
                        align="center"
                      >
                        <v-card-text
                          style="
                            text-align: justify;
                            font-style: italic;
                            font-size: 15px;
                            font-family: Times New Roman;
                          "
                          class="primary--text"
                        >
                          Dear Customer, you are one step away from getting your
                          Corporate Glyd Account registered. We are currently
                          verifying your documents and will get back to you in
                          case we need any additional details. Your application
                          number is
                          <a>{{ getcorpList.code }}</a> . <br />
                          <br />For any query you may write to us on
                          <b
                            ><a href="mailto:admin@glyd.com.my" target="_blank"
                              >admin@glyd.com.my</a
                            ></b
                          >
                          or call us on
                          <strong class="primary--text"
                            >+60 3 2786 5380.</strong
                          >
                        </v-card-text>
                      </v-card>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary ml-2" @click="RequestCard"
                          >Back To Login</v-btn
                        >
                      </v-card-actions>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </v-container>
      <v-container
        v-if="
          $store.getters.get_VerificatnStatus != 0 ||
          $store.getters.get_VerificatnStatus != 2
        "
      ></v-container>
      <v-dialog v-model="submitDialoge" width="400" persistent>
        <v-card class="overflow-hidden">
          <v-toolbar class="elevation-0" dense>
            <span> Are you sure you want to submit ? </span>
            <v-spacer></v-spacer>
            <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
          </v-toolbar>
          <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-row class="mt-2" style="margin-left: 200px">
              <v-btn
                text
                width="90px"
                class="mb-4 red--text"
                @click="submitDialoge = false"
                >Back</v-btn
              >
              <v-btn
                text
                width="90px"
                class="mb-4 primary--text"
                @click="finalsubmit1()"
                >Submit</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="loader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-2">
            {{ loaderMsg }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
import Preview from "@/Views/OnBoarding/preview.vue";
//import axios from "axios";
export default {
  components: {
    Preview,
  },
  data: () => ({
    loader: false,
    loaderMsg: "Please stand by",
    submitDialoge: false,
    response: {},
    cCode: "+60",
    file: [],
    selected: [],
    rules: {
      //step 1 rules
      title: [(v) => !!v || "Required"],
      name: [],
    },
    singleSelect: true,
    headersUploader: [
      {
        text: "Documents",
        align: "start",
        sortable: false,
        value: "doc_name",
      },
      {
        text: "File",
        align: "start",
        sortable: false,
        value: "doc_url",
      },
      {
        text: "Status",
        align: "start",
        sortable: false,
        value: "Status",
      },
      {
        text: "Action",
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    defaultButtonText: "Upload",
    // file: null,
    isSelecting: false,
    confirmDeleteDialog: false,
    documentsList: [],
    files: [],
    options: {
      acceptedFileTypes: ["Image/*"],
      clickable: false,
      adapterOptions: {
        url: "./upload.php",
      },
    },
    e1: 1,
    CompanyName: "",
    entitytype: "",
    natureofbusiness: "",
    FName: "",
    MName: "",
    LName: "",
    Designation: "",
    corpList: [],
    getcorpList: [],
    getaddresslist: {
      addressline1: "",
      addressline2: "",

      city: "",
      state: "",
      zip_code: "",
      country: "Malaysia",
    },
    getaddresslist1: {
      addressline1: "",
      addressline2: "",
      city: "",
      state: "",
      zip_code: "",
      country: "Malaysia",
    },
    AccType: "",
    AccName: "",
    BankName: "",

    AccNo: "",
    banklist: [],
    getbankList: [],
    checkbox: false,
    isbus: false,
    AddBankDialog: false,
    rules1: {
      required: (value) => !!value || "Required",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      length: (value) => value.length <= 100 || "Max 100 characters",
    },
    namerules: [
      (v) => !!v || "Required",
      (v) => (v && v.length >= 5) || "Minimum 5 characters",
      (v) => v.length <= 60 || "Name must be less than 60 characters",
    ],
    namerules2: [
      (v) => !!v || "Required",
      (v) => (v && v.length >= 4) || "Minimum 4 characters",
      (v) => v.length <= 25 || "Name must be less than 25 characters",
    ],
    files2: "",
    files3: "",
    files4: "",
    files5: "",
    files6: "",
    files7: "",
    files8: "",
    Addressline1B: "",
    addressline2: "",
    CityB: "",
    StateB: "",
    CountryB: "",
    PostalCodeB: "",
    AccTypes: ["Savings", "Current"],
    BankNames: [
      "Affin Bank Berhad",
      "Alliance Bank Malaysia Berhad",
      "Al Rajhi Banking and Investment Corporation (M) Berhad",
      "Ambank/Amfinance",
      "Bangkok Bank Berhad",
      "Bank Islam Malaysia Berhad",
      "Bank Kerjasama rakyat Malaysia Berhad",
      "Bank Muamalat Malaysia Berhad",
      "Bank of America",
      "Bank of China (Malaysia) Berhad",
      "Bank Pertanian Malaysia Berhad (AGROBANK)",
      "Bank Simpanan Nasional Berhad",
      "BNP Paribas Malaysia Berhad",
      "China Construction Bank (M) Berhad",
      "CIMB Bank Berhad",
      "Citibank Berhad",
      "Deutsche Bank (M) Berhad",
      "Hong Leong Bank",
      "HSBC Bank Malaysia Berhad",
      "Industrial and Commercial Bank of China (M) Berhad",
      "J.P. Morgan Chase Bank Bhd",
      "Kuwait Finance House (M) Berhad",
      "Maybank",
      "MBSB Bank Berhad",
      "Mizuho Corporate Bank Malaysia Berhad",
      "MUFG Bank (M) Berhad",
      "OCBC Bank (M) Berhad",
      "Public Bank Berhad/Public Islamic Bank Berhad",
      "RHB Bank",
      "Standard Chartered Bank Malaysia Berhad",
      "Sumitomo Mitsui Banking Corporation Malaysia Berhad",
      "United Overseas Bank Berhad",
    ],
    SalesReps: ["SR1245", "JO2613", "GF5213"],
    RefPartners: ["User1", "User2"],
    RelManager: ["TD213", "YY5364"],
    SalUp: ["1", "2", "4"],
    headersBank: [
      {
        text: "Acc Type",
        align: "start",
        sortable: false,
        value: "account_type",
      },
      {
        text: "Acc Name",
        align: "start",
        sortable: false,
        value: "account_name",
      },

      {
        text: "Bank Name",
        align: "start",
        sortable: false,
        value: "bank_name",
      },
      {
        text: "Acc No",
        align: "start",
        sortable: false,
        value: "bank_account_num",
      },
      {
        text: "Actions",
        align: "start",
        sortable: false,
        value: "actions",
      },
      {
        text: "Primary Acc",
        align: "start",
        sortable: false,
        value: "primary_acc",
      },
    ],
    // headersBankMobile: [
    // {
    //     text: "Acc Type",
    //     align: "start",
    //     sortable: false,
    //     value: "account_type",
    //   },
    //   {
    //     text: "Acc Name",
    //     align: "start",
    //     sortable: false,
    //     value: "account_name",
    //   },

    //   {
    //     text: "Bank Name",
    //     align: "start",
    //     sortable: false,
    //     value: "bank_name",
    //   },
    //   {
    //     text: "Acc No",
    //     align: "start",
    //     sortable: false,
    //     value: "bank_account_num",
    //   },
    //   {
    //     text: "Actions",
    //     align: "start",
    //     sortable: false,
    //     value: "actions",
    //   },
    //   {
    //     text: "Primary Acc",
    //     align: "start",
    //     sortable: false,
    //     value: "primary_acc",
    //   },

    // ],
    editindex: "",
    UploadDocs: [
      { text: "DOCUMENTS", width: "", value: "Documents" },
      { text: "FILES", width: "", value: "File" },

      { text: "ACTION", width: "", value: "Action" },
    ],
    editcheck: false,
    previewcheck: "",
    natureofbusinesses: [
      "Construction",
      "Manufacturing",
      "Hotel and Restaurant",
      "Retail trade",
      "Agriculture",
      "Arts and entertainment",
      "Education",
      "Finance and insurance",
      "Health care",
      "Transportation and warehousing",
      "Utilities",
      "Wholesale trade",
      "Information and cultural industries",
      "Management of companies and enterprises",
      "Mining, oil and gas",
      "Scientific and technical services",
      "Public administration",
      "Real estate",
      "Waste Management",
      "Others",
    ],
    typeofentities: [
      "Company",
      "Partnership",
      "Sole Proprietorship",
      "Society",
      "Club",
      "Association",
    ],
    documents: ["Payroll Agreement", "Others"],
    carduserid: "",
    eddDocs: [],
    documentsupload: "",
    documentsuploadname: "",

    missingDocList: [],
    fileList: [],
    itemForDelete: "",
    loadingAdd: false,
    filelistOrg: [],
    stateList: [],
    cardIFullname: "",
    cardIMiddlename: "",
    cardILastname: "",
    cardIEmail: "",
    cardMobilNo: "",
    countryCode: "60",
    carddesignatn: "",
    cardNRIC: "",
    dialogDelete: false,
    docid: "",
    checkdata: [],
    DocID: "",
    isInvalidInput: false,
    error: false,
    redcolor: "",
    invalidcontact: "",
  }),

  created() {
    //this.createbasicinfo();
    this.getbasicinfo();
    // console.log(
    //   "get_VerificatnStatus",
    //   this.$store.getters.get_VerificatnStatus
    // );
    //  console.log("dsfyhi", this.$store.getters.get_corpid);
    if (
      this.$store.getters.get_VerificatnStatus == 0 ||
      this.$store.getters.get_VerificatnStatus == 2
    ) {
      this.e1 = 1;
    }
    if (
      this.$store.getters.get_VerificatnStatus == 3 &&
      this.$store.getters.get_InWrkflow == 1
    ) {
      this.e1 = 7;
    }
  },
  mounted() {
    this.getbasicinfo();

    this.det = this.$store.getters.get_corpid;
    // this.getStatesList = this.$store.getters.get_org_details;
    //this.getStatesList();
    this.getStatesList();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    showBankHeader() {
      var arrayHearder = [...this.headersBank];
      console.log("headersBank", [...this.headersBank]);

      if (this.getbankList.length == 0 || this.getbankList.length == 1) {
        arrayHearder.splice(5, 1);
          console.log("valueArray", arrayHearder);
        return arrayHearder;
      } else {
        return this.headersBank;
      }
    },
    buttonText() {
      return this.file ? this.file.name : this.defaultButtonText;
    },
  },
  methods: {
    validateInput() {
      if (this.cardMobilNo.length >= 2) {
        const fifthChar = this.cardMobilNo[0]; // 5th character (0-indexed)
        // const sixthChar = this.cardMobilNo[1]; // 6th character (0-indexed)

        if (fifthChar == 0) {
          this.redcolor = "red";
          this.error = true;
          this.invalidcontact = "Invalid Contact Number";
        } else {
          this.error = false;
          this.redcolor = "";
          this.invalidcontact = "";
        }
      } else {
        this.error = false;
      }
    },
    validateInput1() {
      if (this.getcorpList.contact_num.length >= 2) {
        const fifthChar = this.getcorpList.contact_num[0]; // 5th character (0-indexed)
        // const sixthChar = this.cardMobilNo[1]; // 6th character (0-indexed)

        if (fifthChar == 0) {
          this.redcolor = "red";
          this.error = true;
          this.invalidcontact = "Invalid Contact Number";
        } else {
          this.error = false;
          this.redcolor = "";
          this.invalidcontact = "";
        }
      } else {
        this.error = false;
      }
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Z a-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    finalsubmit(data) {
      // console.log("Dataaaa", data);
      this.previewcheck = data.data;
      if (this.previewcheck == 1) {
        this.submitDialoge = true;
      }
      if (this.previewcheck == 2) {
        this.e1 = 5;
      }
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    // onFileChanged(e) {
    // console.log(e);
    // this.file = e.target.files[0];
    // console.log(this.file);
    // do something
    // },
    finalsubmit1() {
      this.submitDialoge = false;
      if (this.previewcheck == 1) {
        // this.getbasicinfo();
        this.finalapicall();
        // this.e1 = 7;
      } else if (this.previewcheck == 2) {
        this.e1 = 5;
      }
    },
    async finalapicall() {
      //   console.log(this.$store.getters.get_corpid);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "WFTAB",
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };
      var responseData = await apiCall(inputData);
      //   console.log("kkkWFTABkkk", responseData);
      if (responseData.data.status == "00") {
        this.getbasicinfo();
        this.e1 = 7;
        this.submitDialoge = false;
      }
    },
    showContent(data) {
      //   console.log(data);
      //   console.log(this.getbankList.indexOf(data));
      this.AccType = data.account_type;
      this.AccName = data.account_name;
      this.BankName = data.bank_name;
      this.AccNo = data.bank_account_num;
      this.editcheck = true;
      this.AddBankDialog = true;
      this.editindex = this.getbankList.indexOf(data);
    },
    deleteContent(data) {
      var index = this.getbankList.indexOf(data);
      this.getbankList.splice(index, 1);
      this.$store.commit("snackbar/showMessage", {
        content: "Successfully Deleted",
        color: "green",
      });
    },
    savebankinfo() {
      //    console.log(this.AccNo);
      var self = this;
      self.getbankList.forEach(function (ele, index) {
        //   console.log(index);
        if (index == self.editindex) {
          (ele.account_name = self.AccName), (ele.account_type = self.AccType);
          ele.bank_account_num = self.AccNo;
          ele.bank_name = self.BankName;
        }
      });
      this.AddBankDialog = false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async getStatesList() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GSTATES",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("kkkkkk", responseData.data.data);
      this.stateList = responseData.data.data;
    },
    changeCheckBox(value) {
      if (this.getbankList.length != 1) {
        var index1 = this.getbankList.indexOf(value);
        this.getbankList.forEach((element, index) => {
          if (index == index1) {
            element.primary_acc = true;
          } else {
            element.primary_acc = false;
          }
        });
      }
    },
    async stepperforth() {
      //   console.log(this.carduserid);
      // if (this.carduserid == "") {
      //   alert(20);
      // }
      if (this.$refs.cardInfo.validate() && this.error == false) {
        // alert(1);
        var inputData = {
          method_name: "CORPONBOARD",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "FSTCARD",
            corp_id: this.$store.getters.get_corpid,
            first_name: this.cardIFullname,
            middle_name: this.cardIMiddlename,
            last_name: this.cardILastname,
            countrycode: this.countryCode,
            mobile_no: this.cardMobilNo,
            designation: this.carddesignatn,
            email_id: this.cardIEmail,
            idnum: this.cardNRIC,
            userid: this.carduserid == "" ? 0 : this.carduserid,
          },
        };
        // console.log("inputData", inputData);
        var responseData = await apiCall(inputData);
        // console.log("card", responseData);
        if (responseData.data.status == "00") {
          this.e1 = 5;
          this.getinforoffirstcard();
          this.getbankinfo();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
      }
    },
    async getinforoffirstcard() {
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "FCINFO",
          corp_id: this.$store.getters.get_corpid, //"16", //"4",
        },
      };
      var responseData = await apiCall(inputData);
      this.response = responseData;
      // console.warn("", responseData);
    },
    async dovalidatin() {
      if (this.fileList == "" || this.fileList == []) {
        this.$store.commit("snackbar/showMessage", {
          content: "Please Upload Documents",
          color: "red",
        });
      } else {
        this.e1 = 4;
        // this.getbankinfo();
        this.getUploadedDocuments();
        this.getInfoCardDetails();
      }
    },
    async getInfoCardDetails() {
      //  console.log("vv", this.$store.getters.get_corpid);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GFSTCARD",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      //   console.log("thigetInfoCardDetails", responseData);

      if (responseData.data.status == "00") {
        this.cardIFullname = responseData.data.data.fname;
        this.cardIMiddlename = responseData.data.data.mname;
        this.cardILastname = responseData.data.data.lname;
        this.cardIEmail = responseData.data.data.email_id;
        this.cardMobilNo = responseData.data.data.mobileno;
        this.carddesignatn = responseData.data.data.designation;
        this.cardNRIC = responseData.data.data.idnum;
        this.carduserid = responseData.data.data.userid;
      }
    },
    async sendataforUrl(value) {
      //  console.log("kkkkkk", value);
      var arraytoSend = [];
      arraytoSend.push({
        doc_type: 1,
        doc_id: 0,
        corp_id: this.$store.getters.get_corpid,
        doc_url: value.doc_url,
        doc_name: value.doc_name,
      });

      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "INSURL",
          documents: arraytoSend,
        },
      };
      var responseData = await apiCall(inputData);

      this.filelistOrg = [];
      this.filelistOrg = [...this.fileList];
      console.warn(responseData);
      this.getUploadedDocuments();

      this.loadingAdd = false;
    },
    async deleteItemFile() {
      //console.log("this.itemForDelete.doc_id,", this.itemForDelete.doc_id);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "DELDOC",
          doc_id: this.DocID,
        },
      };
      //   console.log("inputData", inputData);
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.fileList.splice(this.indexOfItemToDelete);
        // console.log(responseData);
        this.getUploadedDocuments();

        this.confirmDeleteDialog = false;
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.confirmDeleteDialog = false;
      }
    },
    getFileFormat(baseData) {
      const byteString = atob(baseData.split(",")[1]);
      const mimeString = baseData.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    },
    getExtension(filename) {
      var i = filename.lastIndexOf(".");
      return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
    },
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    confirmdeleteItem(item) {
      this.itemForDelete = item;
      this.indexOfItemToDelete = this.fileList.indexOf(item);
      this.DocID = item.doc_id;
      // console.log("dsfdsfdsfsdfsd",this.indexOfItemToDelete);
      this.confirmDeleteDialog = true;
    },
    beforeaddingfile() {
      if (this.file == "" || this.documentsupload == "") {
        // this.loadingAdd = false;
        this.$store.commit("snackbar/showMessage", {
          content: "Please select document and upload a file",
          color: "red",
        });
      } else {
        this.addFile();
      }
    },
    addFile() {
      this.missingDocList = [];
      let docItem = {
        doc_name:
          this.documentsupload == "Other Documents"
            ? this.documentsuploadname
            : this.documentsupload,
        doc_url: this.file,
        docExtn: this.getExtension(this.file.name),
        fileName: this.file.name,
        size: this.file.size,
        doc_type: 1,
        doc_id: 0,
      };

      // let docIndex = this.fileList.indexOf(docItem);
      var reader = new FileReader();
      // var self = this;
      // reader.onload = (e) => {
      //   console.log("******************************")
      //   console.log(e.target)
      //   console.log("******************************")
      //   docItem.doc_url = e.target.result;
      //   self.uploadDoc(docItem);
      // };
      this.uploadDoc(docItem);
      reader.readAsDataURL(this.file);
      this.file = [];
      this.loadingAdd = false;
      // this.documentsupload = "";
      this.$refs.uploadForm.reset();
    },

    async uploadDoc(fileItem) {
      this.loader = true;
      // console.log(fileItem)
      let file = fileItem.doc_url; //this.getFileFormat(fileItem.doc_url);
      var inputData = {
        method_name: "ONUPLOAD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "UPLOAD",
          file_name: fileItem.fileName,
          doc_id: 0,
          upload_type: 8,
          // upload_type: 1,
          // corp_id: this.$store.getters.get_corpid,     for future enchancement
        },
      };

      var responseData = await apiCall(inputData, file);
      //console.log("responseData", responseData);
      // console.log(
      //   "kkkkkkkkthis.fileList[index]kkkkkkkkk",
      //   this.fileList[index]
      // );
      this.loader = false;
      if (responseData.data.status == "00") {
        this.fileList.push(fileItem);
        let docIndex = this.fileList.indexOf(fileItem);
        this.fileList[docIndex].doc_url = responseData.data.data.media_url;
        if (
          this.$store.getters.getApiCredentials.baseUrl.includes("dev") == true
        ) {
          this.fileList[docIndex].fileName = this.fileList[
            docIndex
          ].doc_url.split(
            "https://glyd-dev.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
          )[1];
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("staging") ==
          true
        ) {
          this.fileList[docIndex].fileName = this.fileList[
            docIndex
          ].doc_url.split(
            "https://glyd-stage.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
          )[1];
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("corporate") ==
          true
        ) {
          this.fileList[docIndex].fileName = this.fileList[
            docIndex
          ].doc_url.split(
            "https://glyd-prod.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
          )[1];
        }

        var self = this;
        // setTimeout(() => {
        self.sendataforUrl(this.fileList[docIndex]);
        // }, 500);

        this.documentsupload = "";
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
      } else {
        // this.fileList = [];
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
    },
    async createbankinfo(value) {
      if (value == 0) {
        if (this.$refs.Addbankinfo.validate()) {
          var row = {
            account_name: this.AccName,
            account_type: this.AccType,
            bank_name: this.BankName,
            bank_account_num: this.AccNo,
            primary_acc: 0,
          };
          this.getbankList.push(row);
          //  console.log(this.getbankList);
          this.AccName = "";
          this.AccType = "";
          this.BankName = "";
          this.AccNo = "";
          this.$refs.Addbankinfo.resetValidation();
          this.AddBankDialog = false;
        }
      } else if (value == 1) {
        //  console.log("this.selected", this.selected);
        //  console.log("this.getbankList", this.getbankList);
        if (this.getbankList.length == 1) {
          this.getbankList.forEach((element) => {
            if (element.primary_acc == 0) {
              element.primary_acc = true;
            }
          });
          // this.submitDialoge = true;
          this.createbankinfo("2");
        } else {
          var valid = false;
          this.getbankList.forEach((element) => {
            if (element.primary_acc == true) {
              valid = true;
            }
          });
          if (valid == false) {
            this.$store.commit("snackbar/showMessage", {
              content: "Please Select Primary Account",
              color: "red",
            });
          } else if (valid == true) {
            // this.submitDialoge = true;
            this.createbankinfo("2");
          }
        }
      } else if (value == 2) {
        this.getbankList.forEach((element) => {
          if (element.primary_acc == true) {
            element.primary_acc = 1;
          } else {
            element.primary_acc = 0;
          }
        });
        //  console.log("elementgetbankList", this.getbankList);
        var inputData = {
          method_name: "CORPONBOARD",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "BANKINSERT",
            logged_user_id: this.$store.getters.get_userid,
            corp_id: this.$store.getters.get_corpid,
            bank_details: this.getbankList,
          },
        };

        var responseData = await apiCall(inputData);
        //console.log("bankcreateinfo", responseData);
        // if (responseData.data.status == "00") {
        this.banklist = responseData;
        this.e1 = 6;
        this.submitDialoge = false;
        // }
      }
    },

    async getbankinfo() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "BANKGET",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("fg", responseData);
      this.getbankList =
        responseData.data.data == "" || responseData.data.data == null
          ? []
          : responseData.data.data;

      // var self = this;
      // this.selected = [];
      this.getbankList.forEach(function (ele) {
        if (ele.primary_acc == 1) {
          ele.primary_acc = true;
          // self.selected.push(ele);
        } else {
          ele.primary_acc = false;
        }
      });
    },

    calladdress() {
      if (this.checkbox === true) {
        this.getaddresslist1.addressline1 = this.getaddresslist.addressline1;
        this.getaddresslist1.addressline2 = this.getaddresslist.addressline2;
        this.getaddresslist1.city = this.getaddresslist.city;
        this.getaddresslist1.state = this.getaddresslist.state;

        this.getaddresslist1.zip_code = this.getaddresslist.zip_code;
      } else if (this.checkbox === false) {
        this.getaddresslist1.addressline1 = "";
        this.getaddresslist1.addressline2 = "";
        this.getaddresslist1.city = "";
        this.getaddresslist1.state = "";

        this.getaddresslist1.zip_code = "";
      }
    },
    basicmethod() {
      if (this.$refs.formStep1.validate()) {
        this.createbasicinfo();
      }
    },
    addressmethod() {
      if (this.$refs.formStep2.validate()) {
        this.getSeletedDropdnEntity();
        this.e1 = 3;

        this.createaddressinfo();
        this.getUploadedDocuments("start");
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Please fill the required fields",
          color: "red",
        });
      }
    },
    getSeletedDropdnEntity() {
      switch (this.getcorpList.ent_type) {
        case "Company":
        case "Partnership":
          this.documentsList = [
            "Photocopy of IC / Passport (Front & Back) of Director(s) / Partner(s) / Owner(s)",
            "SSM Company Profile Summary Document",
            "Other Documents",
          ];
          break;
        case "Society":
        case "Club":
        case "Association":
        case "Sole Proprietorship":
          this.documentsList = [
            "Photocopy of IC / Passport (Front & Back) of Director(s) / Partner(s) / Owner(s)",
            "SSM Company Profile Summary Document",
            "Certificate of Registration (Form 3 - Association)",
            "Copy of Rules & Regulation or Constitution",
            "Other Documents",
          ];
          break;
      }
    },
    async getUploadedDocuments() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETDOC",
          id: this.$store.getters.get_corpid,

          type: 1,
        },
      };
      var responseData = await apiCall(inputData);
      this.checkdata = responseData.data.data;
      for (let i = 0; i < this.checkdata.length; i++) {
        this.docid = this.checkdata[i].doc_id;
        // console.log("docid", this.docid);
      }

      this.fileList = [];
      this.filelistOrg = [];
      if (this.checkdata != null) {
        var self = this;
        if (
          this.$store.getters.getApiCredentials.baseUrl.includes("dev") == true
        ) {
          this.checkdata.forEach(function (ele) {
            var filesplit = ele.doc_url.split(
              "https://glyd-dev.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
            )[1];
            self.fileList.push({
              doc_name: ele.doc_name,
              doc_url: ele.doc_url,
              fileName: filesplit,
              docExtn: self.getExtension(filesplit),
              doc_id: ele.doc_id,
            });
          });
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("staging") ==
          true
        ) {
          this.checkdata.forEach(function (ele) {
            var filesplit = ele.doc_url.split(
              "https://glyd-stage.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
            )[1];
            self.fileList.push({
              doc_name: ele.doc_name,
              doc_url: ele.doc_url,
              fileName: filesplit,
              docExtn: self.getExtension(filesplit),
              doc_id: ele.doc_id,
            });
          });
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("corporate") ==
          true
        ) {
          this.checkdata.forEach(function (ele) {
            var filesplit = ele.doc_url.split(
              "https://glyd-prod.s3.ap-southeast-1.amazonaws.com/CPORTAL/Common/"
            )[1];
            self.fileList.push({
              doc_name: ele.doc_name,
              docUrl: ele.doc_url,
              fileName: filesplit,
              docExtn: self.getExtension(filesplit),
              doc_id: ele.doc_id,
            });
          });
        }
      }

      self.filelistOrg = [...self.fileList];

      //  console.log("GETDOC1responseDataresponseData", self.fileList);
    },
    // async getUploadedDocuments(){
    //  var inputData = {
    //         method_name: "CORPONBOARD",
    //         page_no: 0,
    //         record_count: 0,
    //         page_size: 25,
    //         app_code: "CPORTAL",
    //         method_param: {
    //           action: "GETDOC",
    //           corp_id: this.$store.getters.get_corpid,
    //         },
    //       };
    //        var responseData = await apiCall(inputData);
    //        this.Somedata = responseData.data.data

    //        for(let i=0;i<this.Somedata.length;i++){
    //          this.docid = this.Somedata[i].doc_id
    //  console.log("docid",this.docid);
    // }
    // },

    bankmethod() {
      // this.e1 = 3;
      this.createbankinfo();
    },

    async createaddressinfo() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "ADDRESSUPDATE",
          reg_adrs: {
            addressline1: this.getaddresslist.addressline1,
            addressline2: this.getaddresslist.addressline2,
            city: this.getaddresslist.city,
            state: this.getaddresslist.state,
            country: "Malaysia",
            zip_code: this.getaddresslist.zip_code,
            is_bus_adrs: this.checkbox,
          },
          bus_adrs: {
            addressline1: this.getaddresslist1.addressline1,

            addressline2: this.getaddresslist1.addressline2,
            city: this.getaddresslist1.city,
            state: this.getaddresslist1.state,
            country: "Malaysia",
            zip_code: this.getaddresslist1.zip_code,
          },
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      this.addresslist = responseData;
      //  console.log("inputDatadfdgdf", this.addresslist);
    },
    async getaddressinfo() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "ADDRESSGET",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      //console.log("ssss", responseData);

      var datareg = responseData.data.data.regaddress;
      var databus = responseData.data.data.busaddress;

      if (datareg != null) {
        this.getaddresslist = datareg;
        this.isbus = datareg.is_bus_adrs;
        // var add2 = datareg.address.split("##")[1];
        // this.getaddresslist.address = datareg.address.split("##")[0];
        // this.getaddresslist.addressline2 = add2;
      }
      if (databus != null) {
        this.getaddresslist1 = databus;
        // var addbus2 = databus.address.split("##")[1];
        // this.getaddresslist1.address = databus.address.split("##")[0];
        // this.getaddresslist1.addressline2 = addbus2;
      }

      this.e1 = 2;
      // this.$refs.Viewonboardpreview.addressdata = this.getaddresslist;
      // this.$refs.Viewonboardpreview.getaddresslist1 = this.getaddresslist1;
      if (this.isbus == true) {
        this.checkbox = true;
      } else {
        this.checkbox = false;
      }
      //  console.log("addressdatareg", this.getaddresslist);
      //  console.log("addressdata", this.getaddresslist1);
    },
    async createbasicinfo() {
      // alert(20);
      //  console.log("this.getcorpList.comp_name,", this.getcorpList);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "BASICINSERT",
          comp_name: this.getcorpList.comp_name,
          registration_num: this.getcorpList.registration_num,
          ent_type: this.getcorpList.ent_type,
          nat_of_busn: this.getcorpList.nat_of_busn,
          first_name: this.getcorpList.first_name,
          middle_name: this.getcorpList.middle_name,
          last_name: this.getcorpList.last_name,
          designation: this.getcorpList.designation,
          contact_num: this.getcorpList.contact_num,
          user_id: this.$store.getters.get_userid,
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      //console.log("inputDatainputData", responseData);
      this.$store.commit("SET_corpid", responseData.data.data.corp_id);
      // this.corpList = responseData.data.data;
      // console.log("postbas", this.corpList);

      this.getaddressinfo();
      // this.getbasicinfo();
    },
    async getbasicinfo() {
      //  console.log(this.$store.getters.get_corpid);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "BASICGET",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log("BASICGET", responseData);

      this.getcorpList = responseData.data.data;
      // this.$refs.Viewonboardpreview.getbasicinfo1 = responseData.data.data[0];
      if (responseData.data.data == null) {
        this.getcorpList = [];
      }
      // console.log("basicdata", this.getcorpList);
      //   console.log(this.$store.getters.get_useremail);
    },
    back() {
      this.e1--;
    },
    back5() {
      this.getInfoCardDetails();
      this.e1 = 4;
    },
    backmethod() {
      this.e1--;
      this.getaddressinfo();
    },
    RequestCard() {
      location.reload();
    },
    Preview_image(files) {
      //   console.log("mmmmmmmmmmmmmmmmmmmmmmm", this.files);
      this.url = URL.createObjectURL(this.files);
      this.files = [...files];
    },
    Preview_image2doc() {
      this.url2 = URL.createObjectURL(this.files2);
    },
    Preview_image3() {
      this.url3 = URL.createObjectURL(this.files3);
    },
    Preview_image4() {
      this.url4 = URL.createObjectURL(this.files4);
    },
    Preview_image5() {
      this.url5 = URL.createObjectURL(this.files5);
    },
    Preview_image6() {
      this.url6 = URL.createObjectURL(this.files6);
    },
    Preview_image7() {
      this.url7 = URL.createObjectURL(this.files7);
    },
    Preview_image8() {
      this.url8 = URL.createObjectURL(this.files8);
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editObject = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItemConfirm() {
      this.getbankList.splice(this.editedIndex, 1);
      this.closeDelete();
    },
  },
};
</script>

<style>
.text {
  font-size: 1rem;
}
#onboard {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
h1 {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: xx-large;
  color: navy;
}
.navbar {
  background: linear-gradient(
    to bottom,
    #2e4152 0%,
    #3c4d5d 50%,
    #202c37 100%
  ) !important;
}
#fileee {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#login {
  height: 100%;
  width: 100%;
  /* position: fixed; */
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-image: url("~@/assets/GlydBackground.png");
  background-position: center center;
  /* -webkit-filter: blur(4px);
  filter: blur(4px); */
  /* background-color: black; */
  /* background-color: white; */
  background-repeat: no-repeat;
  background-size: 100%;
}
</style>
